import * as React from 'react'
import ThemeConsumer from 'ui/multi-product/components/ThemeConsumer'
import classnames from 'classnames'
import { css } from 'emotion'
import { LifeInsuranceProductSubTypeOtherPolicy, OfferSelectionState } from '..'
import { getOpacityColor } from 'embed/utils'

const commonStyles = require('embed/styles/results')
const styles = require('./styles')

interface Props {
  offerSelection: OfferSelectionState
  changeTab: (id: string) => void
  isCustomizable: boolean
  hasOffers: boolean
  loadingCustomizedOffer: boolean
  totalOtherOffers: number
}

export const TogglePolicies: React.FC<Props> = ({
  offerSelection,
  changeTab,
  isCustomizable = false,
  hasOffers = false,
  loadingCustomizedOffer = false,
  totalOtherOffers,
}) => {
  const otherPoliciesTabSelected = (tabId) =>
    tabId === LifeInsuranceProductSubTypeOtherPolicy.OtherPolicies ? !totalOtherOffers : false
  return (
    <ThemeConsumer>
      {({ borderRadiusSmall, ctaStyles, fontFamilyPrimary }) => (
        <div
          className={classnames(
            styles.togglePoliciesContainer,
            {
              [styles.togglePoliciesContainerWithCustomize]: isCustomizable && hasOffers,
              [styles.togglePoliciesContainerNoCustomize]: !isCustomizable && hasOffers,
            },
            css`
              button {
                border-radius: ${borderRadiusSmall};
                font-family: ${fontFamilyPrimary};
                &:hover {
                  opacity: 0.84;
                }
              }
            `,
          )}
        >
          {offerSelection.tabs.map((tab) => {
            const buttonColor = offerSelection.selectedTab === tab.id ? ctaStyles?.backgroundColor : '#9F9F9F'
            return (
              <button
                key={tab.id}
                className={classnames(commonStyles.button, styles.policiesToggleButton)}
                style={{
                  color: buttonColor,
                  borderColor: buttonColor,
                  backgroundColor: getOpacityColor(buttonColor, 5),
                }}
                id={tab.id}
                disabled={loadingCustomizedOffer || otherPoliciesTabSelected(tab.id)}
                // tslint:disable: jsx-no-lambda
                onClick={() => changeTab(tab.id)}
              >
                {tab.label}
              </button>
            )
          })}
        </div>
      )}
    </ThemeConsumer>
  )
}
